import { brandBlueDark, charcoal, closeGreen, lightPurple } from '../shared/colors';
import { respondTo } from '../shared/breakpoints';


const MvlGeneralStyles = `
* {
  box-sizing: border-box;
}
html,
body {
  max-width: 100%;
  &.no-scroll {
    overflow: hidden;
  }
}
html{
   overflow-x: hidden;
}
body {
  font-family: 'proxima-nova', sans-serif;
  font-size: 16px;
  overflow-x: clip;
  color: ${charcoal};
  
}

.no-wrap{
  text-wrap: no-wrap;
}

a,
button {
  font-family: inherit;
}

sup {
  vertical-align: top;
  position: relative;
  top: -0.24em;
  font-size: max(60%, 8px);
}
  .fw-400{
  font-weight: 400;
  }
  .fw-700{
  font-weight: 700;
  }
sub {
  vertical-align: bottom;
  position: relative;
  bottom: -0.3em;
  font-size: max(42%, 10px);
}
.no-wrap {
  white-space: nowrap;
}
em {
  font-style: italic;
}
strong {
  font-weight: bold;
}
.mob-onlyspace{
  display:none
    @media (min-width: 768px) {
    display:block
  }
 }
   .redlink{
   color:rgb(214, 49, 38)}  

.r-size {
font-size: max(60%, 8px);
}

span{
  &.blue-highlight{
    color: ${brandBlueDark};
  }
  &.green-highlight{
    color: ${closeGreen};
  }
  &.purple-highlight{
    color: ${lightPurple};
  }
  
}
     
`;


export default MvlGeneralStyles;